import script from "./AComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AComponent.vue?vue&type=script&setup=true&lang=js"

import "./AComponent.vue?vue&type=style&index=0&id=552ecf9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552ecf9c"]])

export default __exports__